<template>
  <div class="contract-list tab-table p-2">
    <contract-table change-permission="change_customer" delete-permission="delete_customer"
                    export-permission="export_customer" :customer-uuid="customer.uuid" object-name="customer"
                    :object-uuid="customer.uuid" />
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ContractTable from "@/modules/contracts/ContractTable";

  const {mapState} = createNamespacedHelpers('customer/customerView');
  const {mapActions: contractsMapActions} = createNamespacedHelpers('contracts');


  export default {
    name: "Contracts",
    components: {ContractTable},
    computed: {
      ...mapState({
        customer: state => state.customer,
      }),
    },
    methods: {
      ...contractsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'customer',
        extraFilters: {
          customer_uuid: this.customer.uuid,
          exclude_type: 'receipt_contract,pre_receipt_contract'
        }
      });
    }
  }
</script>

<style scoped>

</style>
